import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import { Toast } from '@salesforce/design-system-react';
import * as Util from '../../../common/utilities';

class DataExtensionToast extends Component {
  componentDidUpdate(prevProps) {
    // Show toast for a new active import taking place
    if (Util.propChanged(prevProps, this.props, 'dataExtensions.data.status')) {
      if ('queued' === this.props.dataExtensions.data.status) {
        const dataExtension = this.props.dataExtensions.data.selected?.name;
        const {
          profile_changes: profileChanges
        } = this.props.dataExtensions.data;
        this.props.actions.openToast('profileAttributesSaved', {
          dataExtension,
          profileChanges
        });
        this.props.actions.clearDataExtensionStatus();
      }
    }

    // Show toast for just saving the DE modal without syncing
    if (
      Util.propChanged(
        prevProps,
        this.props,
        'dataExtensions.data.importNow',
        false
      )
    ) {
      this.props.actions.openToast('profileDESaved');
    }

    // Show toast when there was an error creating the import
    if (
      Util.propChanged(
        prevProps,
        this.props,
        'dataExtensions.importCreateError'
      )
    ) {
      this.props.actions.openToast('profileAttributesError');
    }
  }

  render() {
    const { formatMessage } = this.props.intl;
    if (this.props.toast.profileAttributesSaved) {
      const {
        dataExtension,
        profileChanges
      } = this.props.toast.profileAttributesSaved;
      const heading = formatMessage(
        { id: 'components.ecs.attributes.profileAttributesSaved.heading' },
        { dataExtension }
      );
      const details = formatMessage(
        { id: 'components.ecs.attributes.profileAttributesSaved.details' },
        { ...profileChanges }
      );
      return (
        <Toast
          labels={{ heading, details }}
          variant="success"
          duration={10000}
          onRequestClose={() =>
            this.props.actions.closeToast('profileAttributesSaved')
          }
        />
      );
    }

    if (this.props.toast.profileDESaved) {
      const heading = formatMessage({
        id: 'components.ecs.attributes.profileDESaved.heading'
      });
      return (
        <Toast
          labels={{ heading }}
          variant="success"
          duration={10000}
          onRequestClose={() => this.props.actions.closeToast('profileDESaved')}
        />
      );
    }

    if (this.props.toast.profileAttributesError) {
      const heading = formatMessage({
        id: 'components.ecs.attributes.profileAttributesError.heading'
      });
      return (
        <Toast
          labels={{ heading }}
          variant="error"
          onRequestClose={() =>
            this.props.actions.closeToast('profileAttributesError')
          }
        />
      );
    }

    return null;
  }
}

DataExtensionToast.propTypes = {
  actions: PropTypes.object.isRequired,
  dataExtensions: PropTypes.object.isRequired,
  toast: PropTypes.object.isRequired
};

export default injectIntl(DataExtensionToast);
